import type { SVGProps } from "react";

const CalendarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="2.5"
        y="3.33333"
        width="15"
        height="14.1667"
        rx="1.66667"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinejoin="round"
      />
      <path d="M2.5 7.5H17.5" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.66667 1.66667V5" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3333 1.66667V5" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CalendarIcon;
